module.exports = __webpack_public_path__ + "img/vessel-highlight-circle.53d33073.svg";